import Date from '../date/Date';

export default class MealPlan {
    static fromData(data) {
        if (!data) {
            return;
        }

        const mealPlan = new MealPlan();
        mealPlan.id = data.id;
        mealPlan.start = Date.fromIso8601(data.start);
        mealPlan.days = {
            monday: data.days.monday,
            tuesday: data.days.tuesday,
            wednesday: data.days.wednesday,
            thursday: data.days.thursday,
            friday: data.days.friday,
        };
        mealPlan.files = data.files;
        mealPlan.deleteFiles = [];
        mealPlan.range = `${mealPlan.start.toString()} - ${mealPlan.start.addDays(6).toString()}`;
        mealPlan.translations = data.translations;

        return mealPlan;
    }

    static createEmpty(date) {
        const mealPlan = new MealPlan();
        mealPlan.id = null;
        mealPlan.start = date;
        mealPlan.days = {
            monday: '',
            tuesday: '',
            wednesday: '',
            thursday: '',
            friday: '',
        };
        mealPlan.files = [];
        mealPlan.deleteFiles = [];
        mealPlan.range = `${mealPlan.start.toString()} - ${mealPlan.start.addDays(6).toString()}`;

        return mealPlan;
    }

    serialize() {
        return {
            start: this.start.toApiDto(),
            days: {
                monday: this.days.monday,
                tuesday: this.days.tuesday,
                wednesday: this.days.wednesday,
                thursday: this.days.thursday,
                friday: this.days.friday,
            },
            updateFiles: this.files.map((f) => {
                return {
                    id: f.id,
                    title: f.title,
                };
            }),
            deleteFiles: this.deleteFiles.map((f) => f.id),
        };
    }
}
